window.onscroll = function() {myFunction()};

var header = document.getElementById("shopify-section-header");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("color-menu");
  } else {
    header.classList.remove("color-menu");
  }
}



//custom accordion ingr
$('.as-faqs .faq-tabs .tab-btn').on('click', function() {  
  $(this).toggleClass('open');
  $(this).next('.tab-content').toggleClass('open').slideToggle(); 
});
